import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { StatItem, StatItemList, StatItemMoney, StatItemNumber, StatItemPercent, StatItemSeconds, StatItemHours, StatItemMinutes } from 'components/Stats';


export const LoadingText = ({ className,...props}) => (
  <div className={cx('loading-text', className)} />
)

export const LoadingBox = ({ className, size,...props}) => (
  <div className={cx('loading-shine box', className)} />
)



export const LoadingStatItem = ({ className, size, showThumb = false, statCount=4, ...props}) => (
  <div className={cx("g-loading-stat-item", className, size)}>
      <div className="left-info">
        { showThumb && 
        <div className="loading-thumb loading-text" />}
        { !showThumb && <>
          <div className="label loading-text" />
          <div className="value loading-text" />
        </>}
      </div>
      <StatItemList>
        { _.map(Array(statCount), (v,idx) => <StatItem key={idx} loading={true} label="0" />)}
      </StatItemList>
    </div>
)

